const EXCHANGE_ONLINE_HOST_MARKERS = [
  '.office365.com',
  '.office.com',
  '.office365.us',
  '.cloud.microsoft',
];

const isMicrosoft365MailboxHost = (url: string | undefined): boolean =>
  !!url && EXCHANGE_ONLINE_HOST_MARKERS.some((marker) => url.toLowerCase().includes(marker));

export const getIsOnPremises = () => {
  const { mailbox } = Office.context;

  // https://learn.microsoft.com/en-us/javascript/api/outlook/office.userprofile?view=outlook-js-1.6#outlook-office-userprofile-accounttype-member
  const accountType = mailbox?.userProfile?.accountType;
  if (accountType && accountType !== 'enterprise') {
    return false;
  }

  // Outlook also reports 'enterprise' for some Exchange Online mailboxes, so we confirm
  // against the endpoint host. The EWS endpoint is authoritative: in hybrid deployments
  // restUrl can be a Microsoft 365 host even for on-prem mailboxes, so it must not override
  // a non-M365 ewsUrl.
  const ewsUrl = mailbox?.ewsUrl;
  if (ewsUrl) {
    return !isMicrosoft365MailboxHost(ewsUrl);
  }

  const restUrl = mailbox?.restUrl;
  if (restUrl) {
    return !isMicrosoft365MailboxHost(restUrl);
  }

  // No endpoints to check, non-enterprise accounts are already ruled out above.
  return true;
};
